<ng-container *ngIf="control; else skeleton">
<dk-ctl-sablon #sablonCmp
    [isReadOnly]="isReadOnly" [labelText]="labelText" [labelMode]="labelMode" [title]="title" [code]="code"
    (handleValueChange)="handleValueChange($event)" (codeChanges)="code = $event" [isCompulsory]="isCompulsory"
    [validationRules]="validationRulesMap" [validationV2]="validationV2" [warningMessage]="warningMessage"
    (searchClick)="searchClick()"
    (clear)="clear()">
</dk-ctl-sablon>  
<dx-popup *ngIf="crudPopupVisible"
    title="Birim Arama"
    [resizeEnabled]="false"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="crudPopupVisible"
    (onHiding)="closePopupAfter($event, sablonCmp)"
>
        <dk-ctl-vgen-birim-arama
        [control]="control"
        [isGelenBelge]="isGelenBelge"
        [isShowIcBirimler]="isShowIcBirimler"
        [isOnlyGrid]="isOnlyGrid"
        [selectedBirimTuru]="birimTuru"
        [notInIcBirimler]="notInIcBirimler"
        (closePopup)="closePopupAfter($event, sablonCmp)"
        ></dk-ctl-vgen-birim-arama>
</dx-popup>
<dx-toast [(visible)]="toastVisible" type="error" [message]="toastMessage" [displayTime]="3000">
</dx-toast>
</ng-container>
<ng-template #skeleton>
  <div class="skeleton-control"></div>
</ng-template>
